/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Updates the state of a Moov issued card.
 *
 * @remarks
 * - `closed`: The card is permanently deactivated and cannot approve authorizations. A card can be closed by request or when it expires.
 */
export const UpdateIssuedCardState = {
  Closed: "closed",
} as const;
/**
 * Updates the state of a Moov issued card.
 *
 * @remarks
 * - `closed`: The card is permanently deactivated and cannot approve authorizations. A card can be closed by request or when it expires.
 */
export type UpdateIssuedCardState = ClosedEnum<typeof UpdateIssuedCardState>;

/** @internal */
export const UpdateIssuedCardState$inboundSchema: z.ZodNativeEnum<
  typeof UpdateIssuedCardState
> = z.nativeEnum(UpdateIssuedCardState);
/** @internal */
export const UpdateIssuedCardState$outboundSchema: z.ZodNativeEnum<
  typeof UpdateIssuedCardState
> = UpdateIssuedCardState$inboundSchema;
